
if ($(".char-counter").length) {
  $(".char-counter").each(function (idx, item) {
    let $counter = $(item);
    let rest = 0;
    let label = "";
    $($counter.data("field")).on("keyup", function () {
      rest = $counter.data("amount") - $(this).val().length;
      label = global.Translator.transChoice(
        "form.fields.char_counter",
        rest,
        { num: rest > 0 ? rest : -rest },
        "js"
      );
      $counter.text(label);
      if (rest < 0) {
        $counter.addClass("error");
      } else {
        $counter.removeClass("error");
      }
    });
    $($counter.data("field")).trigger("keyup");
  });
}
